import { ErrorMessage } from '@hookform/error-message';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCreateMultipleUploads } from 'app/features/documents/CreateNodesForm';
import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import {
  DocumentAttachment,
  filesValidationSchema,
  MultiFileSelector,
} from 'Components/Buttons/MultiFileUploader';
import ErrorMessageStyle from 'Components/Form/ErrorMessageStyle';
import { useEffect } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { QuestionnaireDocument } from '.';

export const validationSchema = Yup.object().shape({
  files: filesValidationSchema.min(1, 'Required'),
});
type FormInputs = {
  files: DocumentAttachment[];
};

export function UploadNewQuestionnaireDocuments({
  onUpload,
  projectId,
}: {
  projectId: number;
  onUpload: (uploded: QuestionnaireDocument[]) => void;
}) {
  const methods = useForm<FormInputs>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      files: [],
    },
  });
  const { handleSubmit, control, formState, setValue, getValues } = methods;
  const [Upload, { results, isLoading }] = useCreateMultipleUploads();

  useEffect(() => {
    if (results) {
      const newstate = (getValues('files') || []).map((x) => {
        const { isError, isLoading, isUnitialized, isSuccess } =
          results[x.uuid];
        return {
          ...x,
          isError,
          isLoading,
          isSuccess,
          isUnitialized,
        };
      });
      setValue('files', newstate);
    }
  }, [JSON.stringify(results)]);

  const onSubmit: SubmitHandler<FormInputs> = (form) => {
    Upload({
      files: form.files,
      object_type: 'document',
      title: '',
      project_id: projectId,
    }).then(({ endpoints, isAllSuccess }) => {
      if (endpoints && isAllSuccess) {
        const questionnaireDocuments: QuestionnaireDocument[] = endpoints
          .map((e) => e.data!)
          .map((f) => ({
            id: f.id,
            title: f.title,
            url: f.file_url,
          }));
        setValue('files', []);
        onUpload(questionnaireDocuments);
      } else {
        const failedEndpointsIds = endpoints
          .filter((e) => e.isError)
          .map((fe) => fe.id);
        setValue(
          'files',
          (form.files || []).filter((f) => failedEndpointsIds.includes(f.uuid)),
        );
      }
    });
  };

  return (
    <form
      id="upload-form"
      onSubmit={(e) => {
        e.stopPropagation();
        e.preventDefault();
        handleSubmit(onSubmit)(e);
      }}
      className="h-full flex-1 grid gap-2 overflow-y-auto"
    >
      <Controller
        name="files"
        control={control}
        render={({ field }) => (
          <ScrollContainer>
            <ScrollContainer>
              <MultiFileSelector
                errors={formState.errors.files}
                onChange={field.onChange}
                value={field.value || []}
                isLoading={isLoading}
              />
              <ErrorMessage
                errors={formState.errors}
                name="files"
                render={({ message }) => (
                  <ErrorMessageStyle message={message} />
                )}
              />
            </ScrollContainer>
          </ScrollContainer>
        )}
      />
    </form>
  );
}
